import React, { MutableRefObject } from 'react';
import { ReelImage } from './ReelImage';
import { ReelVideo } from './ReelVideo';
import { useGet } from '../../hooks/useApi';
import { ReelSession } from './model/ReelSession';
import { isPhoto, isVideo } from '../../models/FileModel';
import Player from 'video.js/dist/types/player';
import { FilesAPI } from '../../APIs/filesApi';

export type ReelFileDisplayProps = {
    fileId: string;
    session: ReelSession;
    videoTimeSeconds?: number;
    videoRef: MutableRefObject<Player | null>;
};
export const ReelFileDisplay = ({
    fileId,
    session,
    videoTimeSeconds,
    videoRef,
}: ReelFileDisplayProps) => {
    const file = useGet(FilesAPI.item(fileId));
    if (file.isLoading || !file.data) {
        videoRef.current = null;
        return <div className="reel--box-container reel--mode--loading"></div>;
    }
    if (!file.data.data.file?.url) {
        return <>???</>;
    }
    if (isPhoto(file.data.data)) {
        videoRef.current = null;
        return (
            <ReelImage
                fileId={fileId}
                src={file.data.data.file.url}
                session={session}
            />
        );
    }
    if (isVideo(file.data.data))
        return (
            <ReelVideo
                src={file.data.data.file.url}
                videoTimeSeconds={videoTimeSeconds ?? 0}
                ref={videoRef}
            />
        );
    return <></>;
};
